import { Link } from "react-router-dom";

const hubs = [
  { to: "/robotics-companies", title: "Robotics Companies", description: "Manufacturers, developers and active robotics organizations by region." },
  { to: "/robotics-software", title: "Robotics Software", description: "Official simulation, programming, perception and robot-data tools." },
  { to: "/robot-components", title: "Robot Components", description: "Verified actuators, sensors, grippers, computers and safety products." },
];

export default function DirectoryHubLinks({ exclude }) {
  return (
    <section className="site-shell py-12 sm:py-16">
      <h2 className="text-3xl font-black tracking-tight text-neutral-950">Explore the connected robotics directories</h2>
      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {hubs.filter((hub) => hub.to !== exclude).map((hub) => (
          <Link key={hub.to} to={hub.to} className="soft-card soft-card-hover focus-ring p-5">
            <h3 className="text-xl font-black text-neutral-950">{hub.title}</h3>
            <p className="mt-3 text-sm leading-7 text-neutral-600">{hub.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
